"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickAmountButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const smap_1 = require("../smap");
require("./ClickAmountButtons.scss");
function ClickAmountButtons({ current, multiClickOptions, onClick, }) {
    if (Object.keys(multiClickOptions).length > 0) {
        return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ButtonToolbar, { className: "per-click-amount-buttons", children: ["Per Click:", (0, smap_1.mapPairs)(multiClickOptions, (value, display) => {
                    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { onClick: () => onClick(value), active: current === value, children: display }, display));
                })] }));
    }
    return null;
}
exports.ClickAmountButtons = ClickAmountButtons;
